import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import TriplejackLogoImage from '../../assets/tj-logo.png';
import { useAppSelector } from '../../redux/store';
import { LoginPanel } from './loginPanel';
import { SignUpPanel } from './signUpPanel';
export const EntrySceneMainContent = () => {
    const entryMode = useAppSelector((state) => state.gameEntry.entryMode);
    return (_jsxs("div", { css: css `
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
      `, children: [_jsx("img", { src: TriplejackLogoImage, width: 350, height: 290, alt: 'Triplejack logo' }), _jsx("div", { css: css `
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px;
        `, children: entryMode === 'login' ? _jsx(LoginPanel, {}) : _jsx(SignUpPanel, {}) })] }));
};
